import {Swiper} from "swiper";
import {FreeMode, Navigation, Pagination} from "swiper/modules";
import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {gsap} from "gsap/gsap-core";


$('body').on('click', '.js--open-service-modal', function (event) {
  const serviceToOpen = $(this).data('service-to-open');
  $('.js--services-modal[data-service-name="' + serviceToOpen + '"]').addClass('modal-active')
  $('body').addClass('overflow-hidden');
  $('html').addClass('overflow-hidden');

  smoothScrollPause();
});


$('body').on('click', '.js--activate-extra-services', function (event) {
  $('.js--activate-extra-services .arrow-down').toggleClass('rotated');
  $('.js--calculator-service-price-list').toggleClass('active');
});

$('body').on('click', '.js--services-modal .inner-children', function (event) {
  event.stopPropagation();
});

$('body').on('click', '.js--services-modal .inner-parent', function (event) {
  const modal = $('.js--services-modal')
  modal.removeClass('modal-active');
  $('body').removeClass('overflow-hidden');
  $('html').removeClass('overflow-hidden');
  smoothScrollPlay();
});
$('body').on('click', '.js--switch-service-modal-tab', function (event) {
  $('.js--switch-service-modal-tab').removeClass('active')
  $(this).addClass('active');
  var serviceToOpen = $(this).data('tab-to-activate');
  $('.js--current-service-modal-tab').removeClass('active')
  $('.js--current-service-modal-tab[data-service-tab-id="' + serviceToOpen + '"]').addClass('active')
});
let calculatorExtraServiceSwiper;
let fixedServiceModals = []
window.initCalculatorExtraServiceSlider = () => {
  const sliderContainer = document.querySelectorAll('.js--calculator-extra-service-slider')[0]
  if (calculatorExtraServiceSwiper) {
    calculatorExtraServiceSwiper.destroy(true, true); // Destroy Swiper instance

    calculatorExtraServiceSwiper = null; // Set swiper to null
  }
  let nextBtn = sliderContainer.querySelector('.js--swiper-nav-next')
  let prevBtn = sliderContainer.querySelector('.js--swiper-nav-prev')
  calculatorExtraServiceSwiper = new Swiper(sliderContainer, {
    modules: [FreeMode, Navigation, Pagination],
    spaceBetween: 8,
    slidesPerView: 1.4,
    centeredSlides: false,
    freeMode: {
      enabled: false
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn
    },
    breakpoints: {
      768: {
        slidesPerView: "auto",
      },
      992: {
        slidesPerView: 1.8,
      },
      1280: {
        slidesPerView: 2,
      }
    },
    loop: false,
    autoHeight: false,
  })

  $('.js--services-modal').each(function (index) {

    if ($(this).hasClass('js--inited-service-modal')) {
      $(this).remove()
    } else {
      if (fixedServiceModals[index]) {
        ScrollTrigger.getById(`serviceModalFixed${index}`).kill(true)
        gsap.set($(this), {clearProps: true})
        fixedServiceModals[index].kill(true)
        fixedServiceModals[index] = null
      }
      $(this).addClass('js--inited-service-modal');

      fixedServiceModals[index] = ScrollTrigger.create({
        trigger: '#smooth-wrapper',
        id: `serviceModalFixed${index}`,
        pin: $(this),
        top: 'top top',
        start: "top top",
        scrub: true,
        pinReparent: true,
        pinType: 'fixed',
        pinSpacing: false,
        endTrigger: 'footer',
        end: 'bottom+=30000vh bottom',
      });
    }


  });
}
let carTypeSwiper;
window.initCarTypeSwiper = () => {
  if (carTypeSwiper) {
    carTypeSwiper.destroy(true, true); // Destroy Swiper instance
    carTypeSwiper = null; // Set swiper to null
  }
  const sliderContainer = document.querySelectorAll('.car-type-parent')[0]
  if (sliderContainer) {

    let nextBtn = sliderContainer.querySelector('.js--swiper-nav-next')
    let prevBtn = sliderContainer.querySelector('.js--swiper-nav-prev')
    if ($(window).width() < 992) {
      carTypeSwiper = new Swiper('.js--car-type-swiper', {
        modules: [FreeMode, Navigation],
        spaceBetween: 0,
        slidesPerView: 'auto',
        freeMode: {
          enabled: true
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        loop: false
      })
    }
  }
}


window.changeCalculatorStep = (step) => {
  const progressBar = $('.calc-progress-bar')
  $('.calculator-progress-step, .calculator-step').removeClass('active');
  progressBar.removeClass('step-1 step-2 step-3');
  if (step === 'one') {
    $('.calculator-progress-step.step-one, .calculator-step.step-one').addClass('active');
    progressBar.addClass('step-1');
    $('#calculator-page .calc-progress-bar .current-step').text('01');
  } else if (step === 'two') {
    $('.calculator-progress-step.step-two, .calculator-step.step-two').addClass('active');
    progressBar.addClass('step-2');
    $('#calculator-page .calc-progress-bar .current-step').text('02');
  } else {
    $('.calculator-progress-step.step-three, .calculator-step.step-three').addClass('active');
    progressBar.addClass('step-3');
    $('#calculator-page .calc-progress-bar .current-step').text('03');
  }
};

function init() {
  // Basic options for a simple Google Map
  // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
  var mapOptions = {
    // How zoomed in you want the map to start at (always required)
    zoom: 11,
    scrollWheel: false,
    disableDefaultUI: true, // a way to quickly hide all controls
    zoomControl: false,
    // The latitude and longitude to center the map (always required)
    center: new google.maps.LatLng(56.9116, 24.1125),
    gestureHandling: 'none',

    // How you would like to style the map.
    // This is where you would paste any style found on Snazzy Maps.
    styles: [{
      "featureType": "all",
      "elementType": "geometry",
      "stylers": [{"color": "#202c3e"}]
    }, {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [{"gamma": 0.01}, {"lightness": 20}, {"weight": "1.39"}, {"color": "#ffffff"}]
    }, {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [{"weight": "0.96"}, {"saturation": "9"}, {"visibility": "on"}, {"color": "#000000"}]
    }, {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [{"visibility": "off"}]
    }, {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [{"lightness": 30}, {"saturation": "9"}, {"color": "#29446b"}]
    }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"saturation": 20}]}, {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{"lightness": 20}, {"saturation": -20}]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{"lightness": 10}, {"saturation": -30}]
    }, {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [{"color": "#193a55"}]
    }, {
      "featureType": "road",
      "elementType": "geometry.stroke",
      "stylers": [{"saturation": 25}, {"lightness": 25}, {"weight": "0.01"}]
    }, {"featureType": "water", "elementType": "all", "stylers": [{"lightness": -20}]}]
  };

  // Get the HTML DOM element that will contain your map
  // We are using a div with id="map" seen below in the <body>
  var mapElement = document.getElementById('calculator-map');

  // Create the Google Map using our element and options defined above
  var map = new google.maps.Map(mapElement, mapOptions);
  const svgString = `<svg width="35" height="42" viewBox="0 0 35 42" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.497 0C12.8565 0 8.40606 1.86954 5.12474 5.19732C1.84342 8.52511 0 13.0386 0 17.7448C0 23.2946 2.92623 27.792 6.43769 31.5C8.9838 34.1862 17.503 42 17.503 42C17.503 42 26.7101 33.5376 27.5366 32.7054C31.4101 28.771 35 23.7351 35 17.7448C35 13.0386 33.1566 8.52511 29.8752 5.19732C26.5939 1.86954 22.1435 0 17.503 0H17.497Z" fill="#EFBE41"/>
                      </svg>`;
  const encodedSVG = encodeURIComponent(svgString);
  const svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodedSVG;

  var directionsService = new google.maps.DirectionsService();
  var directionsRenderer = new google.maps.DirectionsRenderer({
    polylineOptions: {
      strokeColor: "#EFBE41"
    },
    markerOptions: {
      visible: false,
    }
  });
  directionsRenderer.setMap(map);

  const options = {
    strictBounds: false,
  };

  const inputOne = document.getElementById("point_a_address");
  const inputTwo = document.getElementById("point_b_address");
  const inputOneCoords = $("#point_a_coords");
  const inputTwoCoords = $("#point_b_coords");

  const autocompleteOne = new google.maps.places.Autocomplete(inputOne, options);
  const autocompleteTwo = new google.maps.places.Autocomplete(inputTwo, options);

  autocompleteOne.addListener('place_changed', async function () {
    const place = autocompleteOne.getPlace();
    if (!place.geometry) {
      console.error("Autocomplete's returned place contains no geometry");
      return;
    }
    $('#point_a_index').val(await extractPostalCode(place));
    createMarker(place.geometry.location, map, 'A'); // Add label 'A' for marker A
    inputOneCoords.val(place.geometry.location);
    calculateAndDisplayRoute(directionsService, directionsRenderer);
  });

  autocompleteTwo.addListener('place_changed', async function () {
    const place = autocompleteTwo.getPlace();
    if (!place.geometry) {
      console.error("Autocomplete's returned place contains no geometry");
      return;
    }
    $('#point_b_index').val(await extractPostalCode(place));
    createMarker(place.geometry.location, map, 'B'); // Add label 'A' for marker A
    inputTwoCoords.val(place.geometry.location);
    calculateAndDisplayRoute(directionsService, directionsRenderer);
  });

  window.drawPrevRoute = (origin, destination) => {
    const coordinatesOneArray = origin.slice(1, -1).split(",");
    const coordinatesTwoArray = destination.slice(1, -1).split(",");

// Convert the coordinates to numbers
    const latitudeOne = parseFloat(coordinatesOneArray[0]);
    const longitudeOne = parseFloat(coordinatesOneArray[1]);
    const latitudeTwo = parseFloat(coordinatesTwoArray[0]);
    const longitudeTwo = parseFloat(coordinatesTwoArray[1]);

    const locationObjectOne = {lat: latitudeOne, lng: longitudeOne};
    const locationObjectTwo = {lat: latitudeTwo, lng: longitudeTwo};

    createMarker(locationObjectOne, map, 'A'); // Add label 'A' for marker A
    createMarker(locationObjectTwo, map, 'B'); // Add label 'A' for marker A


    directionsService.route({
      origin: locationObjectOne,
      destination: locationObjectTwo,
      travelMode: google.maps.TravelMode.DRIVING
    }, function (response, status) {
      if (status === 'OK') {
        directionsRenderer.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  async function extractPostalCode(place) {
    let postalCode = "";
    for (const component of place.address_components) {
      if (component.types.includes("postal_code")) {
        postalCode = component.long_name;
        break;
      }
    }

    if (postalCode === "") {
      // If postal code is not found, perform reverse geocoding
      const geocoder = new google.maps.Geocoder();
      const coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      const reversedAddress = await geocoder.geocode({'location': coordinates})
      const postalComponent = reversedAddress.results[0].address_components.find(component => component.types.includes("postal_code"));
      if (postalComponent) {
        postalCode = postalComponent.long_name;
      }
    }
    const countryCode = place.address_components.find(component => component.types.includes("country")).short_name;
    return `${countryCode}-${postalCode}`;
  }


  let previousMarkerA = null;
  let previousMarkerB = null;

  function createMarker(location, map, label) {
    let previousMarker;
    if (label === 'A') {
      previousMarker = previousMarkerA;
      if (previousMarkerA) {
        previousMarkerA.setMap(null); // Remove previous marker A
      }
    } else {
      previousMarker = previousMarkerB;
      if (previousMarkerB) {
        previousMarkerB.setMap(null); // Remove previous marker B
      }
    }


    const marker = new google.maps.Marker({
      position: location,
      map: map,
      label: {
        text: label,
        color: "#191C2B",
        fontFamily: '"Loos Wide", sans-serif',
        fontSize: '0.875rem',
        fontWeight: '500',
      },
      icon: {
        url: svgUrl,
        labelOrigin: new google.maps.Point(17.5, 18) // Adjust the Y value to move the label up or down

      }
    });

    // Move map to marker's location
    map.setCenter(location);

    // Store the current marker as the previous marker based on label
    if (label === 'A') {
      previousMarkerA = marker;
    } else {
      previousMarkerB = marker;
    }

    return marker;
  }

  function calculateAndDisplayRoute(directionsService, directionsRenderer) {
    const originPlace = autocompleteOne.getPlace();
    const destinationPlace = autocompleteTwo.getPlace();

    if (!originPlace?.geometry || !destinationPlace?.geometry) return;

    const origin = originPlace.geometry.location;
    const destination = destinationPlace.geometry.location;

    directionsService.route({
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING
    }, function (response, status) {
      if (status === 'OK') {
        directionsRenderer.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  window.clearRouteAndMarkers = () => {
    directionsRenderer.setDirections({routes: []});
    previousMarkerA?.setMap(null);
    previousMarkerB?.setMap(null);
    $('#point_a_address, #point_b_address').val('');
  }
}


window.changeCarForm = (value, thisEl) => {
  $('.js--calculator-step-two-type').removeClass('active')
  $('.lower-text-single').removeClass('active')
  $(`.lower-text-single[data-info-for="${value}"]`).addClass('active');
  thisEl.classList.add('active')
  let hiddenInput = document.getElementById('car_form');
  hiddenInput.value = value;
}

window.calculatorSecondStepComplete = (data) => {
  smoothScrollPause();
  oc.ajax('onUpdateCalculatorServices', {
    update: {
      'calculators/extra-services': true,
      'calculators/main-delivery-options': true,
      'calculators/prices': true,
    },
  })
  addEventListener('ajax:update-complete', function (event) {
    if (event.detail.context.handler === 'onUpdateCalculatorServices') {
      window.initCalculatorExtraServiceSlider();
      window.changeCalculatorStep('three')
      smoothScrollPlay();
    }
  });
}

window.calculatorDetailingStepOneComplete = (data) => {
  oc.ajax('onUpdateCalculatorServices', {
    update: {
      'calculators/extra-services': true,
      'calculators/detailing/prices': true,
      'calculators/main-delivery-options': true,
    },
  })
  addEventListener('ajax:update-complete', function (event) {
    if (event.detail.context.handler === 'onUpdateCalculatorServices') {
      window.initCalculatorExtraServiceSlider();
      window.changeCalculatorStep('two')
    }
  });
}

window.finishCalculatorSubmit = () => {
  $('.js--confirm-order-calc-step-one, .js--confirm-order-calc-step-two, .confirm-order-form').addClass('d-none');
  $('.js--confirm-order-calc-step-three').removeClass('d-none');
  $('.js--calculator-finish-modal .step-progress').removeClass('active');
  $('.js--calculator-finish-modal .step-finished').addClass('active');
}

window.onCalculatorConfirmClose = () => {
  const modal = $('.js--calculator-finish-modal')
  const goToStepOne = !$('.js--confirm-order-calc-step-three').hasClass('d-none')
  modal.removeClass('modal-active');
  $('body').removeClass('overflow-hidden');
  $('html').removeClass('overflow-hidden');
  smoothScrollPlay();

  $('.js--confirm-order-calc-step-one, .js--confirm-order-calc-step-two, .confirm-order-form, .js--confirm-order-calc-step-three').addClass('d-none');
  $('.js--confirm-order-calc-step-one, .confirm-order-form').removeClass('d-none');
  $('.js--calc-confirm-steps .step-progress').addClass('active');
  $('.js--calc-confirm-steps .step-finished').removeClass('active');
  $('.js--calc-confirm-steps').removeClass('step-2');
  $('.js--calc-confirm-steps .calculator-progress-step-finish').removeClass('active');
  $('.js--calc-confirm-steps .calculator-progress-step-finish.step-1').addClass('active');
  $('.js--calc-confirm-steps .current-step').text('01');
  if (goToStepOne) {
    changeCalculatorStep('one');
    if (window.clearRouteAndMarkers) {
      window.clearRouteAndMarkers();
    }
  }
}


$(document).ready(function () {
  if (!$('.calculator-page').length) {
    return false
  }
  if ($('#calculator-map').length > 0) {
    init();
  }


  $('.js--calculator-return').click(function () {
    changeCalculatorStep($(this).data('step-to-return'));
  });


  $('.js--calculator-type-dropdown, .js--calculator-car-state-dropdown').click(function (event) {
    if (!$(this).hasClass('disabled')) {
      $(this).addClass('active-dropdown');
    }
  });

  $('.js--calculator-type-dropdown .dropdown-list .option').click(function (event) {
    event.stopPropagation();
    $('.js--calculator-type-dropdown .dropdown-list .option').removeClass('active');
    $(this).addClass('active');
    $('.js--calculator-type-dropdown .dropdown-value').text($(this).text());
    $('.js--calculator-type-selector').val($(this).data('type-id')).change();
    $('.js--calculator-type-dropdown').removeClass('active-dropdown');
  });

  $('.js--calculator-car-state-dropdown .dropdown-list .option').click(function (event) {
    event.stopPropagation();
    $('.js--calculator-car-state-dropdown .dropdown-list .option').removeClass('active');
    $(this).addClass('active');
    $('.js--calculator-car-state-dropdown .dropdown-value').text($(this).text());
    $('.js--calculator-car-state-selector').val($(this).data('type-id')).change();
    $('.js--calculator-car-state-dropdown').removeClass('active-dropdown');
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.js--calculator-type-dropdown').length) {
      $('.js--calculator-type-dropdown').removeClass('active-dropdown');
    }
    if (!$(event.target).closest('.js--calculator-car-state-dropdown').length) {
      $('.js--calculator-car-state-dropdown').removeClass('active-dropdown');
    }
  });

  $('.js--calculator-finish-modal .inner-parent .inner-children').on('click mousedown', function (event) {
    event.stopPropagation();
  });

  $('.js--calculator-finish-modal .inner-parent').on('mousedown', function (event) {
    // Record the initial mouse position
    var startX = event.pageX;
    var startY = event.pageY;

    $(document).on('mouseup', function (event) {
      // Calculate the distance moved
      var deltaX = Math.abs(event.pageX - startX);
      var deltaY = Math.abs(event.pageY - startY);

      // Check if the mouse moved significantly
      if (deltaX < 5 && deltaY < 5) {
        // If mouse movement is negligible, trigger the function
        onCalculatorConfirmClose();
      }

      // Remove the mouseup event listener
      $(document).off('mouseup');
    });
  });
  $('.js--open-calculator-finish-modal').on('click', function () {
    $('.js--calculator-finish-modal').addClass('modal-active')
    $('body').addClass('overflow-hidden');
    $('html').addClass('overflow-hidden');
    smoothScrollPause();
  });

  window.goToCalculatorConfirmStepTwo = () => {
    $('.js--calc-confirm-steps').addClass('step-2');
    $('.js--calc-confirm-steps .calculator-progress-step-finish').removeClass('active');
    $('.js--calc-confirm-steps .calculator-progress-step-finish.step-2').addClass('active');
    $('.js--calc-confirm-steps .current-step').text('02');
    $('.js--confirm-order-calc-step-one').addClass('d-none');
    $('.js--confirm-order-calc-step-two').removeClass('d-none');
  };

  $('.js--calculator-confirm-go-to-step-one').on('click', function () {
    $('.js--calc-confirm-steps').removeClass('step-2');
    $('.js--calc-confirm-steps .calculator-progress-step-finish').removeClass('active');
    $('.js--calc-confirm-steps .calculator-progress-step-finish.step-1').addClass('active');
    $('.js--calc-confirm-steps .current-step').text('01');
    $('.js--confirm-order-calc-step-one').removeClass('d-none');
    $('.js--confirm-order-calc-step-two').addClass('d-none');
  });

  $(".js--calc-confirm-textarea").on("keyup", function (e) {
    $('.js--calc-confirm-textarea-count .current').text($(this).val().length)
  });

  window.initCalculatorExtraServiceSlider();
  window.initCarTypeSwiper();

  if ($(window).width() < 992 && $('.js--car-type-swiper').length > 0) {

    ScrollTrigger.create({
      trigger: '.js--car-type-swiper',
      start: "top bottom", // el top, screen bottom
      once: true,
      onEnter: () => {
        $('.js--car-type-swiper').find('.swiper-wrapper').delay(1200).animate({left: '-80px'}, 600,
          function () {
            $(this).animate({left: 0}, 600)
          })
      }
    });
  }
  if ($('#point_b_coords').val() && $('#point_a_coords').val()) {
    drawPrevRoute($('#point_b_coords').val(), $('#point_a_coords').val());
  }
});
